import Search from "pages/PanelPage/components/Search/Search";

export default Search;
